import { useState } from 'react';
import { SearchVehicleUseCase } from '../../application/useCases';
import { Vehicle } from '../../domain/entities';

export const useVehicleSearch = (token: string | null) => {
    const [vehicle, setVehicle] = useState<Vehicle | null>(null);
    const [isLoading, setIsLoading] = useState(false);

    const searchVehicle = async (plateOrCard: string): Promise<Vehicle | null> => {
        if (!token) return null;
        if ((plateOrCard.length < 6 || plateOrCard.length > 7) && plateOrCard.length !== 16) return null;

        try {
            setIsLoading(true);
            const useCase = new SearchVehicleUseCase();
            const result = await useCase.execute(plateOrCard, token);
            setVehicle(result);
            return result;
        } catch (error) {
            console.error('Error searching vehicle:', error);
            setVehicle(null);
            return null;
        } finally {
            setIsLoading(false);
        }
    };

    const clearVehicle = () => {
        setVehicle(null);
    };

    return {
        vehicle,
        isLoading,
        searchVehicle,
        clearVehicle,
    };
};

